var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 010 19V9c0-.55.196-1.02.588-1.412A1.926 1.926 0 012 7h1V5c0-1.383.487-2.563 1.463-3.538C5.437.488 6.617 0 8 0s2.563.487 3.537 1.462C12.512 2.438 13 3.617 13 5v2h1c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412v10c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0114 21H2zm0-2h12V9H2v10zm6-3c.55 0 1.02-.196 1.412-.588.392-.391.588-.862.588-1.412 0-.55-.196-1.02-.588-1.412A1.926 1.926 0 008 12c-.55 0-1.02.196-1.412.588A1.926 1.926 0 006 14c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588zM5 7h6V5c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 008 2c-.833 0-1.542.292-2.125.875A2.893 2.893 0 005 5v2z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSettings);
export default __webpack_public_path__ + "static/media/lock-settings.916aef7f2a2293cc9bce43448f2e5fe8.svg";
export { ForwardRef as ReactComponent };